import { client } from "@/sanity/lib/client";
import {
  faqQuery,
  frontpageContentQuery,
  pageQuery,
  pageSlugsQuery,
  siteSettingsQuery,
} from "@/sanity/lib/queries";
import {
  FaqQueryResult,
  FrontpageContentQueryResult,
  PageQueryResult,
  PageSlugsQueryResult,
} from "@/sanity/types";

export const getFrontpageContent = async (lang: string) => {
  const content = await client().fetch<FrontpageContentQueryResult>(
    frontpageContentQuery,
    { lang }
  );

  return content;
};

export const getPageContent = async (slug: string) => {
  const content = await client().fetch<PageQueryResult>(pageQuery, { slug });

  return content;
};

export const getFAQContent = async (slug: string) => {
  const content = await client().fetch<FaqQueryResult>(faqQuery, { slug });

  return content;
};

export const getAllPageSlugs = async () => {
  const pages = await client().fetch<PageSlugsQueryResult>(pageSlugsQuery);

  return pages.map((page) => page.slug);
};

export const getSiteSettings = async () => {
  return await client().fetch(siteSettingsQuery);
};
